import { render } from "./patient_input.vue?vue&type=template&id=2275c87a&scoped=true"
import script from "./patient_input.vue?vue&type=script&lang=js"
export * from "./patient_input.vue?vue&type=script&lang=js"

import "./patient_input.vue?vue&type=style&index=0&id=2275c87a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2275c87a"]])

export default __exports__